"use client";
import { TabIndicator } from "@chakra-ui/react";
import { useWindowSize } from "usehooks-ts";

export default function FlexTabIndicator(props) {
  const size = useWindowSize();
  return <TabIndicator key={size} {...props} />;
}
